import $ from 'jquery';
import 'slick-carousel';
import {zipWith, merge, map, isNil, reject} from 'ramda';
import qsa from '../../scripts/util/DOM/qsa';
import qs from '../../scripts/util/DOM/qs';
import _ from 'underscore';
import data from './tooltips.json';
import tooltip from '../tooltip/tooltip';
import isElem from '../../scripts/util/isElement';

const selectors = {
	main: '#mac-slider',
	nav: '#mac-slider-nav',
	point: '.js-tooltip-point',
	tooltip: '.js-tooltip',
	template: '#template-tooltip',
	templates: '.templates-container',
	infoCardButton: '.js-info-card-button'
};

_.templateSettings = {
	evaluate: /\{\{(.+?)\}\}/g,
	interpolate: /\{\{=(.+?)\}\}/g,
	escape: /\{\{-(.+?)\}\}/g
};

const template = (() => {
	if (isElem(selectors.template)) {
		const tmpl = qs(selectors.template);
		return {
			container: qs(selectors.templates),
			build: _.template(tmpl.innerHTML.trim())
		};
	}
})();

const renderSliders = () => {
	$(selectors.main).slick({
		infinite: false,
		dots: false,
		arrows: false,
		asNavFor: selectors.nav
	});

	$(selectors.nav).slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		focusOnSelect: true,
		asNavFor: selectors.main,
		arrows: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					adaptiveHeight: true,
					slidesToScroll: 1,
					infinite: false,
					variableWidth: true,
					arrows: false
				}
			}
		]
	});
};

let currentSlideIndex = 0;

const setDataToContainer = list => {
	template.container.innerHTML = list.join(' ');
};

const getPointPosition = index => {
	return $(`.slick-active > [data-point=${index}]`).offset();
};

const getPositionByPoint = point => {
	const index = point.getAttribute('data-point');
	return getPointPosition(index);
};

const getCoordinates = () => {
	const points = qsa(selectors.point);
	const result = map(getPositionByPoint, points);

	return reject(isNil, result);
};

const mergeCoordsWithText = (coordinates, current) => {
	return zipWith(merge, coordinates, data[current]);
};

const renderTooltips = current => {
	const coordinates = getCoordinates();
	const tooltipsData = mergeCoordsWithText(coordinates, current);
	const result = map(template.build, tooltipsData);

	setDataToContainer(result);
	tooltip();

};

const setTooltips = current => {
	currentSlideIndex = current;
	renderTooltips(current);
};

const hideTooltips = () => setDataToContainer([]);

const buildByTimer = () => renderTooltips(currentSlideIndex);

const buidWithCurrentSlideIndex = () => {
	renderTooltips(currentSlideIndex);

	setTimeout(buildByTimer, 800);
};

const afterChange = (event, slick, currentSlide) => {
	setTooltips(currentSlide);
};

const initEvents = () => {
	$(selectors.main).on('beforeChange', hideTooltips);
	$(selectors.main).on('afterChange', afterChange);
	$(selectors.main).on('init', buidWithCurrentSlideIndex);
	$(selectors.main).on('setPosition', buidWithCurrentSlideIndex);
	$(selectors.infoCardButton).on('click', buidWithCurrentSlideIndex);
	window.addEventListener('resize', buidWithCurrentSlideIndex);
	window.addEventListener('orientationchange', buidWithCurrentSlideIndex);
};

const render = () => {
	if (isElem(selectors.main)) {
		renderSliders();
		setTimeout(initEvents, 0);
	}
};

export {
	buidWithCurrentSlideIndex
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/mac-slider/mac-slider.js